/**
 * 文字数を変えない前処理。
 *
 * 抽出結果の `original_fragment` は「元の入力文字列」から切り出す必要があるため、
 * 通常の NFKC のように文字数が変わる正規化は使えない。
 * ここでは 1 文字 → 1 文字の写像だけを行い、インデックスを完全に保つ。
 * （漢数字は文字数が変わりうるので、この段階では変換しない。）
 */

const BRACKET_OPEN = '（(〔［[｛{〈《⦅｟【〖〚';
const BRACKET_CLOSE = '）)〕］]｝}〉》⦆｠】〗〛';

const SPACES = '　      \t';

export function sanitizePreservingLength(input: string): string {
  let out = '';
  for (const ch of input) {
    const code = ch.codePointAt(0)!;

    // 全角数字 ０-９ → 0-9
    if (code >= 0xff10 && code <= 0xff19) {
      out += String.fromCharCode(code - 0xff10 + 0x30);
      continue;
    }
    // 全角英大文字 Ａ-Ｚ
    if (code >= 0xff21 && code <= 0xff3a) {
      out += String.fromCharCode(code - 0xff21 + 0x41);
      continue;
    }
    // 全角英小文字 ａ-ｚ
    if (code >= 0xff41 && code <= 0xff5a) {
      out += String.fromCharCode(code - 0xff41 + 0x61);
      continue;
    }
    if (BRACKET_OPEN.includes(ch)) {
      out += '(';
      continue;
    }
    if (BRACKET_CLOSE.includes(ch)) {
      out += ')';
      continue;
    }
    if (SPACES.includes(ch)) {
      out += ' ';
      continue;
    }
    // サロゲートペアも 1 文字として維持する
    out += ch;
  }
  return out;
}

/** 事件番号の構成要素間の不要な空白を取り除く。 */
export function stripInnerSpaces(s: string): string {
  return s.replace(/[\s　]+/g, '');
}
